import { ROLES } from '@shared/models/employee';

export enum FEATURES {
  AssignReassign = 'AssignReassign',
  UpdateTreatmentPlanModel = 'UpdateTreatmentPlanModel',
  ShowClientPrimaryAccount = 'ShowClientPrimaryAccount',
  ShowChild = 'ShowChild',
  UpdateClientPrimaryAccount = 'UpdateClientPrimaryAccount',
  UpdatePatient = 'UpdatePatient',
  FlagAbility = 'FlagAbility',
}

export const featurePermissionMatrix = [
  { featureName: FEATURES.AssignReassign, roles: [ROLES.SeniorClinician, ROLES.MasterClinician] },
  {
    featureName: FEATURES.UpdateTreatmentPlanModel,
    roles: [ROLES.Admin, ROLES.SuperAdministrator],
  },
  {
    featureName: FEATURES.ShowClientPrimaryAccount,
    roles: [ROLES.SeniorClinician, ROLES.MasterClinician, ROLES.Clinician, ROLES.Admin],
  },
  {
    featureName: FEATURES.ShowChild,
    roles: [ROLES.SeniorClinician, ROLES.MasterClinician, ROLES.Clinician],
  },
  {
    featureName: FEATURES.UpdateClientPrimaryAccount,
    roles: [ROLES.SeniorClinician, ROLES.MasterClinician, ROLES.Clinician],
  },
  {
    featureName: FEATURES.UpdatePatient,
    roles: [ROLES.SeniorClinician, ROLES.MasterClinician, ROLES.Clinician],
  },
  {
    featureName: FEATURES.FlagAbility,
    roles: [ROLES.SeniorClinician, ROLES.MasterClinician, ROLES.Clinician],
  },
];
